import { CalendarDays, FileText, Tags } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { AiContentDetailResponse } from '@shared/api';
import { Badge, CardHeaderRow, Heading } from '@shared/ui';

export function AiContentHeader({
  record,
  typeLabel,
  controls,
  children,
}: {
  record: AiContentDetailResponse['data'];
  typeLabel: string;
  controls?: ReactNode;
  children?: ReactNode;
}) {
  const { t, i18n } = useTranslation();
  return (
    <header className="flex min-w-0 flex-col gap-4 sm:flex-row sm:items-stretch">
      <div className="flex h-profile-header-media w-profile-header-media shrink-0 items-center justify-center border border-border bg-muted">
        <FileText className="size-8 text-muted-foreground" aria-hidden="true" />
      </div>
      <div className="min-w-0 flex-1 space-y-3">
        <CardHeaderRow controls={controls}>
          <Heading as="h1" size="lg" className="min-w-0 break-words">
            {record.title ?? t('crm.missingValue')}
          </Heading>
        </CardHeaderRow>
        <div className="flex flex-wrap gap-2">
          {record.type ? (
            <Badge appearance="outline" icon={<Tags size={16} />} size="md" wrap="wrap">
              {t('aiContent.fields.type')}: {typeLabel}
            </Badge>
          ) : null}
          <Badge appearance="outline" icon={<CalendarDays size={16} />} size="md" wrap="wrap">
            {t('aiContent.fields.updatedAt')}:{' '}
            {new Intl.DateTimeFormat(i18n.resolvedLanguage, { dateStyle: 'medium' }).format(
              new Date(record.updatedAt)
            )}
          </Badge>
        </div>
        {children}
      </div>
    </header>
  );
}
